export default class pinMappa {

	static init() {

		$('.mappa .pin').bind("click", function () {
			$(this).toggleClass('open');
			var targetElement = $(this);
			bodyScrollLock.disableBodyScroll(targetElement); 
			$('.open').not(this).removeClass('open');
		});

	

	}

}
